import React from "react";
export const normalizeLegendItems = (items) => {
    const src = items || [];
    return src.map((li) => {
        if (typeof li === "string") {
            return { key: li.toLowerCase(), label: li };
        }
        const key = (li.key || li.label).toLowerCase();
        return { color: li.color, key, label: li.label };
    });
};
export const classifyWaterfallPoint = (p) => {
    if (p?.isSum || p?.isTotal) {
        return "total";
    }
    if ((p?.y ?? 0) >= 0) {
        return "increase";
    }
    return "decrease";
};
export const WaterfallLegend = ({ items, hidden, toggle, colors }) => {
    if (!items.length) {
        return null;
    }
    return React.createElement("div", { className: "waterfallCustomLegend", role: "list", "aria-label": "Waterfall legend" }, items.map(({ key, label, color: overrideColor }) => {
        const color = overrideColor || colors[key] || colors.increase;
        const isHidden = hidden.has(key);
        return React.createElement("button", { type: "button", onClick: () => toggle(key), key: key, role: "listitem", "aria-pressed": !isHidden, "aria-label": label, className: `waterfallCustomLegend__item ${isHidden ? "is-hidden" : "is-visible"}` },
            React.createElement("span", { className: "waterfallCustomLegend__swatch", style: { background: color } }),
            React.createElement("span", { className: "waterfallCustomLegend__label" }, label));
    }));
};
